"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { Route } from "next";
import { ModeToggle } from "./mode-toggle";
import UserMenu from "./user-menu";
import { Separator } from "@anima/ui/components/separator";
import { authClient } from "@/lib/auth-client";
import { ALL_ENTRY_KINDS, kindListUrl, KIND_LABELS } from "@/lib/routes";
import { z } from "zod";
const headerLinkSchema = z.object({
  to: z.string(),
  label: z.string(),
  icon: z.string().optional(),
  type: z.literal("link")
});
const headerDividerSchema = z.object({
  type: z.literal("divider")
});
const headerSchema = z.discriminatedUnion("type", [headerLinkSchema, headerDividerSchema]);
export default function Header() {
  const $ = _c(17);
  const {
    data: session
  } = authClient.useSession();
  const isAdmin = session?.user.role === "admin";
  const isRequester = session && (session.user.role === "friend" || session.user.role === "admin");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      to: "/",
      label: "Anima",
      type: "link"
    };
    t1 = {
      type: "divider"
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isAdmin || $[3] !== isRequester) {
    let t3;
    if ($[5] !== isRequester) {
      t3 = isRequester ? [{
        type: "divider" as const
      }, {
        to: "/requests",
        label: "Requests",
        type: "link" as const
      }] : [];
      $[5] = isRequester;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== isAdmin) {
      t4 = isAdmin ? [{
        to: "/admin/series",
        label: "Admin",
        type: "link" as const
      }] : [];
      $[7] = isAdmin;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t2 = [t0, t1, ...ALL_ENTRY_KINDS.map(_temp), ...t3, ...t4];
    $[2] = isAdmin;
    $[3] = isRequester;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const links = t2;
  let t3;
  if ($[9] !== links) {
    t3 = <nav className="flex flex-wrap gap-4 text-lg">{links.map(_temp2)}</nav>;
    $[9] = links;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-center gap-2"><ModeToggle /><UserMenu /></div>;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3) {
    t5 = <div className="flex flex-row items-center justify-between px-2 py-1">{t3}{t4}</div>;
    $[12] = t3;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Separator />;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5) {
    t7 = <div>{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
function _temp2(data) {
  if (data.type === "divider") {
    return <Separator orientation="vertical" />;
  }
  const {
    to,
    label
  } = data;
  return <Link key={to + label} href={to as Route}>{label}</Link>;
}
function _temp(kind) {
  return {
    to: kindListUrl(kind),
    label: KIND_LABELS[kind],
    type: "link" as const
  };
}